<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/pc_banner_sup_event.webp`)">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="main-title">
          キャンペーンボーナスの受領方法
        </h1>

        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item" :class="{'is-btn-active': isActive}" @click="toggleActive">
              PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': !isActive}" @click="toggleActive">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents" :class="{'is-contents-active': isActive}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「入金」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/event_pc_tab_01.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                1. 入金方法を選択<br>
                2. 金額を入力<br>
                3. 参加する入金キャンペーンにチェックを入れる<br>
                4. 「入金」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/event_pc_tab_02.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 3
              </h1>
              <h2 class="subheading fs_6">
                入金完了後、ボーナスはすぐに【ボーナスウォレット】に配付されます
              </h2>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/event_pc_tab_03.png`)" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents" :class="{'is-contents-active': !isActive}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「入金」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/event_mb_tab_01.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                1. 入金方法を選択<br>
                2. 金額を入力<br>
                3. 参加する入金キャンペーンにチェックを入れる<br>
                4. 「入金」をクリック
              </h2>
              <div class="img-style-bor-sha ">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/event_mb_tab_02.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 3
              </h1>
              <h2 class="subheading fs_6">
                入金完了後、ボーナスはすぐに【ボーナスウォレット】に配付されます
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/event_mb_tab_03.png`)" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      isActive: true
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>
